import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Maximize"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M931.7375 32H307.8275a59.9625 59.9625 0 0 0-59.9625 59.9625v119.925H92.2625A59.9625 59.9625 0 0 0 32.3 271.85V931.4375a59.9625 59.9625 0 0 0 59.9625 59.9625h659.5875a59.9625 59.9625 0 0 0 59.9625-59.9625V774.9359375h119.925a59.9625 59.9625 0 0 0 59.9625-59.9625V91.9625A59.9625 59.9625 0 0 0 931.7375 32zM751.85 714.9734375V931.4375H92.2625V271.85h659.5875z m177.489375 0H811.8125V271.85a59.9625 59.9625 0 0 0-59.9625-59.9625H307.8275V91.9625H931.7375z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var maximize = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\maximize.vue"]]);

export { maximize as default };
